/**********************************************************************
 * Copyright (C) 2023 Red Hat, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 ***********************************************************************/

import { arch, platform } from 'node:os';
import { join } from 'node:path';

import type { Locator, Page } from '@playwright/test';

export abstract class BasePage {
  readonly page: Page;
  // TODO: extract header and content locators into base class, add that roles into all pages

  constructor(page: Page) {
    this.page = page;
  }

  public getPage(): Page {
    return this.page;
  }

  public async screenshot(options: { name: string; mask?: Array<Locator> }): Promise<void> {
    const path = process.env.PLAYWRIGHT_SCREENSHOTS_PATH;
    if (!path) return;

    await this.page.screenshot({
      path: join(path, `${options.name}-${platform()}-${arch()}.png`),
      mask: options.mask,
    });
  }
}
